// Central map of the legacy brand imagery used across the web app.
//   - Logos come from the report letterhead resources (Image97/Image111),
//     extracted to reportAssets.ts as inline data URIs.
//   - Background art was copied from the legacy apps into /public/legacy
//     (POS Resources/background.jpg, IMS landing page) by
//     migration-tools/extract-report-logos.mjs + the copy step.
import { REPORT_LOGO_LEFT, REPORT_LOGO_RIGHT } from './reportAssets'

// Green "Thomson's" crest used on reports, the app header, and login.
export const THOMSONS_LOGO = REPORT_LOGO_LEFT
export const THOMSONS_BADGE = REPORT_LOGO_RIGHT

// Faded tulip garden-path background from the legacy POS main screen.
export const POS_BACKGROUND = '/legacy/pos/background.jpg'
// IMS landing-page art (white with the green wordmark in the corner).
export const IMS_LANDING = '/legacy/ims/thomspons-landing-page2.jpg'
